<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required?'label-blue':'']"
    :rules="form.rules"
    v-show="!form.options.hidden"
    :required="form.options.required"
     style="padding-left:10px;line-height:36px;"
  >
    <el-row style="width:226px">
      <el-col v-if="form.options.type==='year'">
        <el-date-picker
         style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          @input="onInput"
          @change="numChange"
          type="year"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='date'">
        <el-date-picker
           style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          @change="numChange"
          @input="onInput"
          type="date"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='month'">
        <el-date-picker
           style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          @change="numChange"
          @input="onInput"
          type="month"
           
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='timerange'">
        <el-time-picker
          style="width:100%"
          is-range
          arrow-control
          v-model="value[form.model]"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围">
        </el-time-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='daterange'">
       
        <el-date-picker
         style="width:100%"
          v-model="value[form.model]"
          :disabled="inputDisable"
          @input="onInput"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
        
      </el-col>
      <el-col v-else-if="form.options.type==='monthrange'">
        <el-date-picker
         style="width:100%"
          
          v-model="value[form.model]"
          :disabled="inputDisable"
          @input="onInput"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='datetime'">
        <el-date-picker
         style="width:100%"
          
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          @change="numChange"
          @input="onInput"
          type="datetime"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='datetimerange'">
         <el-tooltip class="item" effect="light" 
     :disabled="value[form.model].length==0"   :content="value[form.model][0]+'至'+value[form.model][1]" placement="top-start">
        <el-date-picker
         style="width:100%"
          v-model="value[form.model]"
          :disabled="inputDisable"
          @input="onInput"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :format="form.options.format"
          :value-format="form.options.format"
          :default-time="form.options.defaultTime"
          clearable
        >
        </el-date-picker>
         </el-tooltip>
      </el-col>
      <el-col v-else-if="form.options.type==='datetimerangeX'">
         <el-tooltip class="item" effect="light" 
     :disabled="value[form.model].length==0"   :content="value[form.model][0]+'至'+value[form.model][1]" placement="top-start">
        <el-date-picker
         style="width:100%"
          v-model="value[form.model]"
          :disabled="inputDisable"
          @input="onInput"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :format="form.options.format"
          :value-format="form.options.format"
          :default-time="form.options.defaultTime"
          clearable
        >
        </el-date-picker>
         </el-tooltip>
      </el-col>
      <el-col v-else-if="form.options.type==='dateX'">
        <el-date-picker
           style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          :picker-options="pickerOptions"
          @change="numChange"
          @input="onInput"
          type="date"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col v-else-if="form.options.type==='monthX'">
        <el-date-picker
           style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          :picker-options="pickerOptionsX"
          @change="numChange"
          @input="onInput"
          type="month"
          :format="form.options.format"
          :value-format="form.options.format"
          clearable
        >
        </el-date-picker>
      </el-col>
    </el-row>
  </el-form-item>
</template>

<script>
import { database } from '../../../libs/util.db';
export default {
  name: "DynamicDatePicker",
  data() {
    let _this=this;
    return {
      key: "",
      formData: {},
      mainValue: "",
      pickerOptions: {
        disabledDate:(time)=>{
            return _this.disabledDateZ(time);
        },
      },
      pickerOptionsX: {
        disabledDate:(time)=>{
            return _this.disabledDateX(time);
        },
      },
    };
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: "",
          prop: "",
          icon: "",
          className: "",
          options: {
            width: "100%",
            defaultValue: "",
            required: false,
            dataType: "date",
            hidden:false,
            pattern: "",
            placeholder: "",
            customClass: "",
            defaultTime:[],
            disabled: false,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: "",
          model: "value",
          rules: [{}]
        };
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value"
  },
  watch: {
    value: {
      immediate: true,
      handler: function(val, oldVal) {
        this.mainValue = val;
      }
    },
  },
  methods: {
    onInput() {
      let that = this;
      that.$emit("input", that.value, that.form.model);
      if (typeof that.form.options.changeFunc === "function") {
        // 判断是否存在数据改变事件
        that.form.options.changeFunc(
          that.value[that.form.model],
          that,
          that.forms
        );
      }
    },
    numChange(val){
      // let that = this
      // if(!val){
      //   that.value[that.form.model]="";
      // }
    },
    setValue(val) {
      this.mainValue = val;
    },
    disabledDateZ(time) {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth();
      var dayt = today.getDate();
      let dateData= new Date(year, month, dayt, "23", "59", "59")
      let curDate = dateData.getTime();
      return time.getTime() > curDate;
    },
    disabledDateX(time) {
      var today = new Date();
      var year = today.getYear();
      if (year < 2000) year += 1900;
      var month = today.getMonth();

      // let dateData= new Date(year+1, 1, '20')
      // let curDate = dateData.getTime();
      // return time.getTime() > curDate;
      //(month+1)
      let dateEData= new Date(year, 11 , '1')
      let dateSData= new Date(year, 0, '1')
      let curEDate = dateEData.getTime();
      let curSDate = dateSData.getTime();
      return time.getTime() < curSDate || time.getTime() > curEDate;
    },
  },
  created() {
    let that = this;
    that.key = that.form.key;
    if (that.form.hasOwnProperty("options")) {
      that.value[that.form.model] =
        that.value[that.form.model] ||
        this.form["options"]["defaultValue"] ||
        "";
    }
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    },
  }
};
</script>

<style scoped>
.el-date-editor .el-range-input{
  font-size: 12px !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicDatePicker.vue"
}
</vue-filename-injector>
